var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('pendencies-details',{attrs:{"moduleId":_vm.moduleId,"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }